import ApiService from './_api.service'
import Utils from '../utils'

const API_MOVEMENTS_URL = '/v1/movements/'

export default {
    async getState(args) {
        const url = API_MOVEMENTS_URL + 'state/'
        const queryParams = Utils.getQueryParams(args)

        const response = await ApiService.get(url + queryParams)

        return response
    }
}